'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _pc = require('@alife/showAgentAuthDialog/lib/pc');

var _pc2 = _interopRequireDefault(_pc);

var _lodash = require('lodash');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _formFieldUtils = require('../common/formFieldUtils');

var _validation = require('../common/validation');

var _validation2 = _interopRequireDefault(_validation);

var _treeOperation = require('../common/treeOperation');

var _face = require('../common/face');

var _constant = require('./constant');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var FaceRecognition = (_temp = _class = function (_Field) {
  _inherits(FaceRecognition, _Field);

  function FaceRecognition(props) {
    _classCallCheck(this, FaceRecognition);

    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    var scanResult = (0, _lodash.get)(props, _constant.FIELD_DATA_VALUE_KEY);

    _this.state = {
      scanResult: (0, _face.getStatusByScanResult)(scanResult)
    };
    return _this;
  }

  FaceRecognition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    // superState意味着超级国家，不适合当变量名。具体例子可见其它文件
    var parentState = _Field.getDerivedStateFromProps.call(this, props, state);
    var scanResult = (0, _face.getStatusByScanResult)((0, _lodash.get)(props, _constant.FIELD_DATA_VALUE_KEY));
    // 扫脸结果不同则需要改变按钮状态
    if (scanResult !== state.scanResult) {
      return _extends({}, parentState, {
        scanResult: scanResult
      });
    }
    return parentState;
  };
  /**
   * 校验是否有手机号码，有的话需要校验手机号码规则
   * 脱敏直接忽略
   * @returns boolean true: 校验通过
   */


  FaceRecognition.prototype.isValidateMobileNumber = function isValidateMobileNumber(telNumber) {
    if (!telNumber || String(telNumber).includes('*')) {
      return true;
    }

    return _validation2.default.mobile.valid(telNumber);
  };

  FaceRecognition.prototype.isValidateIdNumber = function isValidateIdNumber(idNumber) {
    if (String(idNumber).includes('*')) {
      return true;
    }

    return _validation2.default.idCard.valid(idNumber);
  };

  FaceRecognition.prototype.inAdvancedCard = function inAdvancedCard(parents) {
    if ((0, _lodash.isNil)(parents) || !(0, _lodash.isArray)(parents)) {
      return false;
    }

    return parents.some(function (item) {
      return item.componentName === _constant.ADVANCED_CARD_TYPE_NAME;
    });
  };

  FaceRecognition.prototype.inNormalCard = function inNormalCard(parents) {
    if ((0, _lodash.isNil)(parents) || !(0, _lodash.isArray)(parents)) {
      return false;
    }

    return parents.some(function (item) {
      return item.componentName === _constant.CARD_COMPONENT_TYPE_NAME;
    });
  };

  FaceRecognition.prototype.getInstance = function getInstance(component) {
    var _getProps = this.getProps(),
        $props = _getProps.$props,
        componentId = _getProps.componentId,
        context = _getProps.context;

    var fieldId = (0, _lodash.get)(component, 'props.fieldId');
    var iteratorId = $props.iteratorId || componentId;
    return context.getComponentInstance(iteratorId + '_' + fieldId);
  };

  FaceRecognition.prototype.getIndex = function getIndex(parents) {
    var _getProps2 = this.getProps(),
        $props = _getProps2.$props;
    // AUTO_COLUMNS_LAYOUT: 不确定是分栏组件还是灵活分栏


    if (parents.some(function (parent) {
      return (0, _lodash.isEqual)(parent.componentName, _constant.AUTO_COLUMNS_LAYOUT);
    })) {
      var autoColumnField = parents.find(function (parent) {
        return (0, _lodash.isEqual)(parent.componentName, _constant.AUTO_COLUMNS_LAYOUT);
      });
      var instance = this.getInstance(autoColumnField);
      return (0, _lodash.get)(instance, 'props.$props.index', 0);
      // COLUMNS_LAYOUT
    } else if (parents.some(function (parent) {
      return (0, _lodash.isEqual)(parent.componentName, _constant.COLUMNS_LAYOUT);
    })) {
      var columnField = parents.find(function (parent) {
        return (0, _lodash.isEqual)(parent.componentName, _constant.COLUMNS_LAYOUT);
      });
      var _instance = this.getInstance(columnField);
      return (0, _lodash.get)(_instance, 'props.$props.index', 0);
    } else {
      return (0, _lodash.get)($props, 'index', 0);
    }
  };
  /**
   * 获取parent元素下的指定元素(id)的值
   * 需判断是在advanced card还是card下，这两个下面的取值不同
   * @param {*} id
   * @param {*} parent
   * @returns any
   */


  FaceRecognition.prototype.getValueByFieldId = function getValueByFieldId() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _param$id = param.id,
        id = _param$id === undefined ? '' : _param$id,
        _param$parent = param.parent,
        parent = _param$parent === undefined ? {} : _param$parent,
        cardFieldId = param.cardFieldId,
        _param$currentIndex = param.currentIndex,
        currentIndex = _param$currentIndex === undefined ? 0 : _param$currentIndex;

    var _getProps3 = this.getProps(),
        context = _getProps3.context;

    switch (parent.componentName) {
      case _constant.CARD_COMPONENT_TYPE_NAME:
        // 高级卡片中的普通卡片，普通卡片
        var rowData = context.store.get(cardFieldId).getVal();
        // id没有取本身
        return id ? (0, _lodash.get)(rowData, [currentIndex, id]) : rowData[currentIndex];
      case _constant.ADVANCED_CARD_TYPE_NAME:
        return context.store.get(cardFieldId + '>' + id).getVal();
      default:
        if ((context.store.get(id) || {}).getVal) {
          return context.store.get(id).getVal();
        }
        return undefined;
    }
  };
  /**
   * 获取个人用户信息
   * 服务端不支持嵌套卡片脱敏，故嵌套卡片场景，相关脱敏字段不用传
   * @returns
   */


  FaceRecognition.prototype.getPersonalInfo = function getPersonalInfo() {
    var _getProps4 = this.getProps(),
        context = _getProps4.context,
        certNoFieldId = _getProps4.certNoFieldId,
        certNameFieldId = _getProps4.certNameFieldId,
        certPhoneFieldId = _getProps4.certPhoneFieldId,
        initialSchema = _getProps4.initialSchema;

    if (certNoFieldId && certNameFieldId) {
      var idNumber = void 0,
          name = void 0,
          telNumber = void 0,
          cardFieldId = void 0,
          cardValueSchema = void 0,
          cardValueMap = void 0,
          currentIndex = void 0;
      // 注意: getAllParents返回一个数组是为了支持在卡片里可以分栏
      var parentComponents = (0, _treeOperation.getAllParents)(context.schema, (0, _lodash.get)(initialSchema, 'id', ''));
      var inAdvancedCard = this.inAdvancedCard(parentComponents);

      if (inAdvancedCard) {
        var advanceCardField = parentComponents.find(function (component) {
          return (0, _lodash.isEqual)(component.componentName, _constant.ADVANCED_CARD_TYPE_NAME);
        });
        // 嵌套（高级）卡片中的普通卡片
        if (this.inNormalCard(parentComponents)) {
          cardValueSchema = parentComponents.find(function (component) {
            return (0, _lodash.isEqual)(component.componentName, _constant.CARD_COMPONENT_TYPE_NAME);
          });
          // 嵌套id拼接规则
          cardFieldId = (0, _lodash.get)(advanceCardField, 'props.fieldId') + '>' + (0, _lodash.get)(cardValueSchema, 'props.fieldId');
          currentIndex = this.getIndex(parentComponents);
        } else {
          cardValueSchema = advanceCardField;
          cardFieldId = (0, _lodash.get)(advanceCardField, 'props.fieldId');
        }
      } else if (this.inNormalCard(parentComponents)) {
        // 人脸组件在卡片内的那一条数据
        cardValueSchema = parentComponents.find(function (component) {
          return (0, _lodash.isEqual)(component.componentName, _constant.CARD_COMPONENT_TYPE_NAME);
        });
        cardFieldId = (0, _lodash.get)(cardValueSchema, 'props.fieldId', '');
        currentIndex = this.getIndex(parentComponents);
        cardValueMap = this.getValueByFieldId({
          cardFieldId: cardFieldId,
          parent: cardValueSchema,
          currentIndex: currentIndex
        });
      }

      idNumber = this.getValueByFieldId({ id: certNoFieldId, parent: cardValueSchema, cardFieldId: cardFieldId, currentIndex: currentIndex });
      name = this.getValueByFieldId({ id: certNameFieldId, parent: cardValueSchema, cardFieldId: cardFieldId, currentIndex: currentIndex });
      // 电话字段非必填
      if (certPhoneFieldId) {
        telNumber = this.getValueByFieldId({
          id: certPhoneFieldId,
          parent: cardValueSchema,
          cardFieldId: cardFieldId,
          currentIndex: currentIndex
        });
      }

      if (name && this.isValidateIdNumber(idNumber) && this.isValidateMobileNumber(telNumber)) {
        // https://aone.alibaba-inc.com/v2/project/1007124/req/36188025(脱敏字段)
        var bizParam = {
          idType: _constant.ID_CARD,
          idNumber: idNumber,
          name: name,
          telNumber: telNumber
        };
        return {
          success: true,
          data: inAdvancedCard ? bizParam : _extends({}, bizParam, {
            certNoFieldId: certNoFieldId,
            certNameFieldId: certNameFieldId,
            certPhoneFieldId: certPhoneFieldId,
            cardFieldId: cardFieldId,
            cardValueMap: cardValueMap
          })
        };
      }
      return { success: false, errorMsg: '\u8BF7\u68C0\u67E5\u5173\u8054\u7684\u4EBA\u8BC1\u4FE1\u606F\u5B57\u6BB5\uFF1A\u8EAB\u4EFD\u8BC1\u53F7\uFF0C\u59D3\u540D\uFF0C\u624B\u673A\u53F7\u7801\u3002' };
    }
    return { success: false, errorMsg: '没有找到关联人证信息字段。' };
  };

  FaceRecognition.prototype.handleClick = function handleClick() {
    var _this2 = this;

    var personalInfo = this.getPersonalInfo();
    if (!personalInfo.success) {
      _next.Dialog.alert({
        content: personalInfo.errorMsg,
        title: false
      });
      return;
    }

    var _getProps5 = this.getProps(),
        componentId = _getProps5.componentId;

    var _getControlProps = this.getControlProps(),
        onChange = _getControlProps.onChange;

    var _getQuery = (0, _formFieldUtils.getQuery)(),
        sequenceNo = _getQuery.sequenceNo,
        matterId = _getQuery.matterId;

    (0, _pc2.default)({
      action: {
        onSubmit: function onSubmit(data) {
          if ((0, _lodash.isEmpty)(data)) {
            _next.Message.error('data为空');
            return;
          }
          console.log('scan face data:', data);
          _this2.setState({ scanResult: _face.STATUS_MAP.SUCCESS });

          onChange({
            result: true,
            encryptCode: data.cipher,
            certNo: personalInfo.data.idNumber,
            certName: personalInfo.data.name,
            timestamp: new Date().getTime() // https://aone.alibaba-inc.com/v2/project/1061355/bug/35885333
          });
        },
        onFail: function onFail(code) {
          console.log('scan face error:', code);
          _this2.setState({ scanResult: _face.STATUS_MAP.ERROR });
        }
      },
      store: {
        bizScene: 'FORM', // 场景id，后端需要
        bizNo: sequenceNo + '&' + componentId, // 人脸唯一键，后端需要
        bizParam: JSON.stringify(_extends({
          sequenceNo: sequenceNo,
          matterId: matterId
        }, personalInfo.data)),
        authorizer: (0, _lodash.pick)(personalInfo.data, ['idNumber', 'idType', 'name', 'telNumber'])
      },
      component: {
        GlobalMessage: function GlobalMessage() {
          return _react2.default.createElement(
            'span',
            null,
            (0, _face.getAppName)()
          );
        }
      }
    });
  };

  FaceRecognition.prototype.render = function render() {
    var _this3 = this;

    var fieldId = this.props.fieldId;

    var buttonName = (0, _face.getButtonNameByStatus)(this.state.scanResult, this.props.buttonName);
    var commonProps = this.getControlProps();

    return _react2.default.createElement(
      'div',
      { 'data-field-id': fieldId, className: 'vc-form-item-container' },
      _react2.default.createElement(
        _next.Form.Item,
        _extends({}, this.getFormItemProps(), { label: ' ', colon: false, required: false }),
        _react2.default.createElement(
          _next.Button,
          _extends({
            type: 'primary',
            warning: this.state.scanResult === _face.STATUS_MAP.ERROR,
            onClick: function onClick() {
              _this3.handleClick();
            }
          }, commonProps, {
            disabled: (0, _lodash.get)(commonProps, 'disabled', false) || (0, _lodash.get)(commonProps, 'readOnly', false)
          }),
          buttonName
        )
      )
    );
  };

  return FaceRecognition;
}(_vuFusionField2.default), _class.displayName = 'FaceRecognition', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  componentId: null,
  content: null,
  style: null
}), _temp);
exports.default = FaceRecognition;
module.exports = exports['default'];